import { init as initErrorHandler } from './error-handler';
import { init as initCookie } from './cookie';
import { init as initLaunchDarkly } from './launch-darkly';
import { init as initTermsAndConditions } from './terms-and-conditions';
import { init as initPrivacy } from './privacy';
import { init as initAnalytics } from './analytics';
import { init as initBrowser } from './browser';
import { init as initRecaptcha } from './recaptcha';
import { init as initFontLoader } from './font-loader';
import { init as initRouting } from './routing';
import { init as initFreeUser } from './free-users';
import { init as initPlusUsers } from './plus-users';
import { init as initCompatibilityVersion } from './compatibility-version';
import { init as initSubscriptions } from './subscriptions';
import { init as initReducedMotionTracking } from './reduced-motion-tracking';

import ErrorHandler from '@module/error-handler';

const initScripts = () => {
  try {
    initErrorHandler();
    initCookie();
    initTermsAndConditions();
    initPrivacy();
    initAnalytics();
    initBrowser();
    initRecaptcha();
    initFontLoader();
    initFreeUser();
    initPlusUsers();
    initCompatibilityVersion();
    initSubscriptions();
    initReducedMotionTracking();
    // We can remove this from the global scope now, all
    // data has been processed by the initializers
    window['__session__'] = undefined;
  } catch (error) {
    ErrorHandler.track(error);
  }
};

export { initScripts, initRouting, initLaunchDarkly };
